import React, { useCallback } from 'react';
import videosData from '../data/javascripts/videosData';
import VideoCard from '../widgets/VideoCard'; // The specific card component
import HorizontalCardDeck from '../widgets/HorizontalCardDeck';
import ActionButton from '../widgets/ActionButton';

const Videos = () => {

    // Define the click handler needed by the specific card type
    const handleVideoClick = useCallback(
        // 'url' is the full YouTube URL passed from the card (or wherever this is called)
        url => {
            if (url) {
                // Open the URL in a new tab/window
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        },
        [] // No dependencies needed since 'url' is an argument and window.open is a global function
    );

    const renderVideoItem = useCallback((video) => {
        return (
            <VideoCard
                video={video}
                onClick={handleVideoClick}
            />
        );
    }, [handleVideoClick]);

    return (
        <section id="videos" className="bg-bg-light dark:bg-bg-dark">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-8">
                    <h2 className="section-heading text-primary dark:text-secondary">
                        Recent Videos
                    </h2>
                </div>

                {/* --- Using the Generic HorizontalCardDeck --- */}
                <HorizontalCardDeck
                    items={videosData} // The data array
                    renderItem={renderVideoItem} // The function that returns the VideoCard JSX
                    rows={1} // Set rows for large screens
                />

                <div className="text-center mt-12">
                    <ActionButton 
                        text="View MY Channel" 
                        onClick={() =>
                            window.open("https://www.youtube.com/@parallelroutines", "_blank")
                        }
                        className="btn-md"
                    />
                </div>
            </div>
        </section>
    );
};

export default React.memo(Videos);